<template>
  <div>
    <!-- <ak-model-filter-card model="salary" @search="search" @reset="reset" /> -->
    <!-- <a-select
      mode="multiple"
      v-model="_value"
      style="width: 100%"
      placeholder
      :filter-option="false"
      option-label-prop="label"
      refs="filter"
      @search="search"
      @popupScroll="popupScroll"
    >
      <a-select-option
        v-for="(item,index) in gdUser"
        :key="index"
        :value="item.objectId"
        :label="item.name"
      >{{item.name}}</a-select-option>
    </a-select>-->
    <ak-type-input hideLabel v-model="data.sales" :field="options" />
    <!-- <a-radio-group v-model="_value">
      <a-radio-button value="male">男</a-radio-button>
      <a-radio-button value="female">女</a-radio-button>
    </a-radio-group>-->
  </div>
</template>
<script>
import Bus from '@/assets/js/eventBus'
export default {
  syncProps: ['value'],
  props: {
    value: null, // 当前这个字段的值，如果这个字段是虚构的，则必定是空
    field: Object, // 当前field对象
  },
  data () {
    return {
      filters: {},
      // gdUser: [],
      data: {
        sales: []
      },
      options: {
        name: 'sales',
        note: '销售人员',
        type: 'Array',
        items: { type: 'Pointer', targetClass: '_User' },
        listWhere: (where) => {
          where.username = { $exists: true }
        }
      }
      // page: 1,
      // value: []
    }
  },
  // async mounted () {
  //   let res = await this.$modelAjax.get('_User', {
  //     params: {
  //       where: {
  //         adminRole: 'admin'
  //       }
  //     }
  //   })
  //   this.gdUser = res.data.results
  // this.filters = this.$refs.filter.getFilterQuery()
  // },
  mounted () {
    Bus.$on('reset', this.reset)
  },
  methods: {
    filterQuery () {
      console.log(this.data.sales)
      if (this.data.sales.length) {
        this._value = this.data.sales
      } else {
        this._value = 'null'
      }
      // if (this._value) {
      return this._value
      // }
    },
    setValue () {
      this._value = null // 不会报错
    },
    async search (filters) {
      // let res = await this.$modelAjax.get('_User', {
      //   params: {
      //     where: {
      //       adminRole: 'admin',
      //       name: filters ? {
      //         $regex: filters
      //       } : undefined
      //     }
      //   }
      // })
      // this.gdUser = res.data.results
    },
    reset (payLoad) {
      this.data.sales = payLoad
    }
  },
}
</script>

<style>

</style>
